import { CoverageScreenType } from './coverage-type';
import { oemSites } from './oem-sites';
import { aOrAn } from '../../../utilities';

const buttonDataSet = {
  defaultButton: () => ({
    text: 'View More Shops',
    link: 'https://yourvehiclecare.com/map/customer',
    buttonType: 'text',
    viewMoreButton: true,
  }),
  findDealershipButton: (make) => ({
    text: `Find ${aOrAn(make)} ${make} dealership`,
    link: `https://www.google.com/search?q=${make}+dealership`,
    viewMoreButton: false,
  }),
  findRepairShopButton: () => ({
    text: 'Find a Repair Center',
    link: 'https://yourvehiclecare.com/map/customer',
    buttonType: 'primary',
    viewMoreButton: false,
  }),
  noButton: () => undefined,
  okButton: () => ({
    text: 'Ok',
    closeModal: true,
  }),
  contactUsButton: () => ({
    text: 'Contact us',
    link: '/help/?open-contact-window=true',
  }),
  makeWebsiteButton: (make) => ({
    text: `${make}'s website`,
    link: oemSites[make?.toLowerCase().replace(/\s/g, '')] || `https://www.google.com/search?q=${make}`,
    buttonType: 'primary',
    viewMoreButton: false,
  }),
};

export const CoverageScreenButton = {
  contactUs: buttonDataSet.contactUsButton,
  limited100Covered: buttonDataSet.defaultButton,
  manufacturerCovered: buttonDataSet.findDealershipButton,
  carvanaCareCovered: buttonDataSet.defaultButton,
  carvanaCareOilTireCovered: buttonDataSet.defaultButton,
  notCovered: buttonDataSet.defaultButton,
  thirtyDayCovered: buttonDataSet.defaultButton,
  conditionallyCoveredBrakes: buttonDataSet.defaultButton,
  notCoveredCosmetic: buttonDataSet.defaultButton,
  notCoveredGlass: buttonDataSet.noButton,
  notCoveredAdditionalCosmetic: buttonDataSet.defaultButton,
  notCoveredAdditionalKey: buttonDataSet.noButton,
  notCoveredMissingAccessories: buttonDataSet.makeWebsiteButton,
  cosmeticSubmitted: buttonDataSet.okButton,
  carvanaCareRoadHazardCovered: buttonDataSet.defaultButton,
  carvanaCareRoadHazardNotCovered: buttonDataSet.noButton,
  carvanaCareOilChangeCovered: buttonDataSet.defaultButton,
  carvanaCareOilChangeNotCovered: buttonDataSet.noButton,
  carvanaCareDentCovered: buttonDataSet.defaultButton,
};

export const getButtonTextAndLink = (coverageScreenType: CoverageScreenType, make) => {
  return CoverageScreenButton[coverageScreenType](make);
};
